/**
 * Detect whether the current environment is a development context.
 *
 * Checks both the build-time NODE_ENV and the runtime hostname so that
 * the guard works in local dev servers, deployed staging with dev flags,
 * and production builds.
 */
export function isDevMode(): boolean {
  try {
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') return true;
    if (typeof window !== 'undefined') {
      const h = window.location?.hostname;
      if (h === 'localhost' || h === '127.0.0.1') return true;
    }
    return false;
  } catch {
    return false;
  }
}
